const Cookies = require('./reverb_cookie.js');

function csrfToken() {
  return Cookies.get('csrf_token');
}

function createOrUpdateTag(name, content) {
  const tag = $(`meta[name=${name}]`);
  if (tag.length) {
    tag.attr('content', content);
  } else {
    $('<meta>')
      .attr('name', name)
      .attr('content', content)
      .appendTo('head');
  }
}

function setMetaTags() {
  createOrUpdateTag('csrf-param', 'authenticity_token');
  createOrUpdateTag('csrf-token', csrfToken());
}

$(document).ready(setMetaTags);

module.exports = {
  setMetaTags,
  csrfToken,
};



// WEBPACK FOOTER //
// ./javascripts/components/set_ajax_meta_tags.js